import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(Box)``;

export const BranchSvg = styled('img')`
  position: absolute;
  bottom: ${(p) => p.theme.spacing(1)};
  left: ${(p) => p.theme.spacing(-2)};
`;
